import React from "react";
import "../../assets/css/Common.css";
import * as Constants from "../../constants/Constants";
import * as LocalConstants from "../../constants/FieldConstants";
import { MACYS_LOGO, HAMBERGER } from "../../assets/js/image";
import DeploymentWarning from "../Header/DeploymentWarning/DeploymentWarning";
import TopNavigation from "./TopNavigation/TopNavigation";
import Cookies from "js-cookie";

const PublicHeader = (props) => {
  return (
    <div>
      {Cookies.get("email") && <DeploymentWarning />}
      <div>
        <div className="headerMain">
          <div className="logoMain col-lg-10 col-md-9">
            <HAMBERGER
              style="hambergerLogo"
              id={LocalConstants.hambergerId}
              altText={Constants.HAMBERGER_ALT_TEXT}
            ></HAMBERGER>
            <MACYS_LOGO
              style="macysLogo"
              id={LocalConstants.macysLogoId}
              altText={Constants.LOGO_ALT_TEXT}
            ></MACYS_LOGO>
            <label className="logoTextStyle" id={LocalConstants.macysLogoText}>
              {Constants.TITLE}
            </label>
          </div>
        </div>
        <TopNavigation />
      </div>
    </div>
  );
};

export default PublicHeader;
